import { render, staticRenderFns } from "./OpenAuctionsPage.vue?vue&type=template&id=374c098e"
import script from "./OpenAuctionsPage.vue?vue&type=script&lang=js"
export * from "./OpenAuctionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports